import React from 'react'

import maingatesrgcomplex from "../images/office (2).jpeg";
import Navbar from '../inc/Navbar';
import ScrollToTop from "react-scroll-to-top";
function Aboutus() {
  return (
    <div>
       <Navbar/>
       <br/>
       <br/>
       <br/>
       <br/>
            <br />
              <ScrollToTop smooth top="100" color="maroon" />
            <div className="album py-0">
                <div className="container">

                    <div className="card-body">
                        <div className='welcometext'>
                            <h1 style={{color:"#B80000"}} className="card-title mb-0"><b>About Us – <b>SRG Group</b></b></h1>
                            <div className="col-md-2">
                                <hr style={{ color: "#1D4D93" }} />
                            </div>
                        </div>
                        <div className="album py-0">
                            <div className="container">
                                <div className="row">

                                    <div className="col-md-7 mt-3">
                                        <div className='mission'>
                                            <h3 style={{ color: "#1D4D93" }} className='mb-2'>Welcome to <b>SRG Complex </b></h3>
                                           <p style={{color:"#1D4D93"}} className='mb-2'>Dear Visitors,</p>
                                    
                                    <p className='justify mb-2'><b style={{color:"#B80000"}} >SRG Group</b> is a trusted name in real estate development, committed to delivering quality homes and land projects that combine modern living with long-term value. With a strong focus on transparency, affordability, and customer satisfaction, we strive to make property ownership simple and secure for every buyer.</p>
                                    <p className='justify mb-1'>At <b style={{color:"#B80000"}} >SRG Complex</b>, we offer thoughtfully planned 2 BHK & 3 BHK villas along with well-located residential land parcels, designed to meet the needs of modern families. Our projects are developed with proper legal approvals, wide road access, and essential infrastructure to ensure a comfortable and peaceful lifestyle.</p>
                                    <p className='justify mb-1'>We believe in building more than just structures — we build trust, relationships, and future-ready communities. From project planning to final handover, our experienced team ensures quality construction, timely delivery, and honest communication at every step.</p>
                                    <p className='justify mb-3'>Whether you are looking for your dream home or a smart investment, SRG Group is here to guide you with reliability and professionalism.</p>
                                    
                                    <h6 style={{color:"#1D4D93"}}>Your dream. Our commitment.</h6>
                                        </div>
                                    </div>
                                    <div className="col-md-5 mt-3">

                                        <img src={maingatesrgcomplex} className="card-img-top" alt="maingatesrgcomplex"/>


                                    </div>





                                </div>
                            </div>
                        </div>
                        <br />






                    </div>
                </div>
            </div>
            <br />
    </div>
  )
}

export default Aboutus